import { render, staticRenderFns } from "./sectionItemThird.vue?vue&type=template&id=1f36e574&scoped=true"
import script from "./sectionItemThird.vue?vue&type=script&lang=ts"
export * from "./sectionItemThird.vue?vue&type=script&lang=ts"
import style0 from "./sectionItemThird.vue?vue&type=style&index=0&id=1f36e574&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36e574",
  null
  
)

export default component.exports